export const AUTH_PREFIX = 'auth/';

export const LOGIN_REQUESTED = `${AUTH_PREFIX}LOGIN_REQUESTED`;
export const FB_LOGIN_REQUESTED = `${AUTH_PREFIX}FB_LOGIN_REQUESTED`;
export const LOGIN_SUCCEEDED = `${AUTH_PREFIX}LOGIN_SUCCEEDED`;
export const LOGIN_FAILED = `${AUTH_PREFIX}LOGIN_FAILED`;

export const SIGNUP_REQUESTED = `${AUTH_PREFIX}SIGNUP_REQUESTED`;
export const SIGNUP_SUCCEEDED = `${AUTH_PREFIX}SIGNUP_SUCCEEDED`;
export const SIGNUP_FAILED = `${AUTH_PREFIX}SIGNUP_FAILED`;

export const PAYMENT_REQUESTED = `${AUTH_PREFIX}PAYMENT_REQUESTED`;
export const PAYMENT_SUCCEEDED = `${AUTH_PREFIX}PAYMENT_SUCCEEDED`;
export const PAYMENT_FAILED = `${AUTH_PREFIX}PAYMENT_FAILED`;

export const PERMISSIONS_REQUESTED = `${AUTH_PREFIX}PERMISSIONS_REQUESTED`;
export const PERMISSIONS_SUCCEEDED = `${AUTH_PREFIX}PERMISSIONS_SUCCEEDED`;
export const PERMISSIONS_FAILED = `${AUTH_PREFIX}PERMISSIONS_FAILED`;

export const ROLE_SWITCH_REQUESTED = `${AUTH_PREFIX}ROLE_SWITCH_REQUESTED`;
export const ROLE_SWITCH_SUCCEEDED = `${AUTH_PREFIX}ROLE_SWITCH_SUCCEEDED`;
export const ROLE_SWITCH_FAILED = `${AUTH_PREFIX}ROLE_SWITCH_FAILED`;

export const UPDATE_USER_REQUESTED = `${AUTH_PREFIX}UPDATE_USER_REQUESTED`;

export const LOGOUT_REQUESTED = `${AUTH_PREFIX}LOGOUT_REQUESTED`;

export const CLEAR_ERROR_MESSAGES = `${AUTH_PREFIX}CLEAR_ERROR_MESSAGES`;

export const CLEAR_FORGOT_FLAGS = `${AUTH_PREFIX}CLEAR_FORGOT_FLAGS`;

export const FORGOT_PASSWORD_REQUESTED = `${AUTH_PREFIX}FORGOT_PASSWORD_REQUESTED`;
export const FORGOT_PASSWORD_SUCCEEDED = `${AUTH_PREFIX}FORGOT_PASSWORD_SUCCEEDED`;
export const FORGOT_PASSWORD_FAILED = `${AUTH_PREFIX}FORGOT_PASSWORD_FAILED`;

export const VERIFICATION_CODE_SET = `${AUTH_PREFIX}VERIFICATION_CODE_SET`;

export const RESET_PASSWORD_REQUESTED = `${AUTH_PREFIX}RESET_PASSWORD_REQUESTED`;
export const RESET_PASSWORD_SUCCEEDED = `${AUTH_PREFIX}RESET_PASSWORD_SUCCEEDED`;
export const RESET_PASSWORD_FAILED = `${AUTH_PREFIX}RESET_PASSWORD_FAILED`;

export const HAS_VISITED_WELCOME_SCREEN_KEY = 'HAS_VISITED_WELCOME_SCREEN_KEY';

export const PARTNER_SIGNUP_REQUESTED = `${AUTH_PREFIX}PARTNER_SIGNUP_REQUESTED`;
export const PARTNER_SIGNUP_SUCCESSFUL = `${AUTH_PREFIX}PARTNER_SIGNUP_SUCCESSFUL`;
export const PARTNER_SIGNUP_FAILED = `${AUTH_PREFIX}PARTNER_SIGNUP_FAILED`;

export const GET_PACKAGE_PRICING_REQUEST = `${AUTH_PREFIX}GET_PACKAGE_PRICING_REQUESTED`;
export const GET_PACKAGE_PRICING_SUCCESSFUL = `${AUTH_PREFIX}GET_PACKAGE_PRICING_SUCCESSFUL`;
export const GET_PACKAGE_PRICING_FAILED = `${AUTH_PREFIX}GET_PACKAGE_PRICING_FAILED`;

export const UPDATE_PARTNER_LICENSE = `${AUTH_PREFIX}UPDATE_PARTNER_LICENSE`;

export const GET_PARTNER_LICENSE = `${AUTH_PREFIX}GET_PARTNER_LICENSE`;

export const GET_PARTNER_LIST_REQUEST = `${AUTH_PREFIX}GET_PARTNER_LIST_REQUESTED`;
export const GET_PARTNER_LIST_SUCCESSFUL = `${AUTH_PREFIX}GET_PARTNER_LIST_SUCCESSFUL`;
export const GET_PARTNER_LIST_FAILED = `${AUTH_PREFIX}GET_PARTNER_LIST_FAILED`;

export const GET_PARTNER_TOKEN_REQUEST = `${AUTH_PREFIX}GET_PARTNER_TOKEN_REQUESTED`;
export const GET_PARTNER_TOKEN_SUCCESSFUL = `${AUTH_PREFIX}GET_PARTNER_TOKEN_SUCCESSFUL`;
export const GET_PARTNER_TOKEN_FAILED = `${AUTH_PREFIX}GET_PARTNER_TOKEN_FAILED`;

export const GET_REFRESH_TOKEN_REQUEST = `${AUTH_PREFIX}GET_REFRESH_TOKEN_REQUESTED`;
export const GET_REFRESH_TOKEN_SUCCESSFUL = `${AUTH_PREFIX}GET_REFRESH_TOKEN_SUCCESSFUL`;
export const GET_REFRESH_TOKEN_FAILED = `${AUTH_PREFIX}GET_REFRESH_TOKEN_FAILED`;

export const SET_SELECTED_PARTNER = `${AUTH_PREFIX}SET_SELECTED_PARTNER`;
export const RESET_VIEW_AS = `${AUTH_PREFIX}RESET_VIEW_AS`;

export const FB_APP_ID = process.env.FB_APP_ID
    ? process.env.FB_APP_ID
    : 1047608948639449;

export const FB_RESPONSE_FIELDS = 'name,email,picture';
export const LOGIN_USERNAME = 'login_username';
export const LOGIN_PASSWORD = 'login_password';

export const AVAILABLE_PACKAGES = {
    CAMPUS_ANNUAL: {
        id: 5,
        name: 'School (Annual)',
        key: 'CAMPUS_ANNUAL',
        price: 99,
        pricingId: 'price_1I4OeFJiTZl5BBhaf1uPnosM',
        period: 'Per Year',
        defaultRoleKey: 'inspire_campus',
    },
    LNGO: {
        id: 1,
        name: 'Local NGO',
        key: 'LNGO',
        price: 500,
        pricingId: 'price_1I6tclJiTZl5BBhaotU1gokD',
        period: 'Per Year',
        defaultRoleKey: 'inspire_ngo',
    },
    CSCIENCE: {
        id: 3,
        name: 'Citizen Science',
        key: 'CSCIENCE',
        price: 500,
        pricingId: 'price_1I6tdTJiTZl5BBhaxHIB3pCQ',
        period: 'Per Year',
        defaultRoleKey: null,
    },
    LBUSINESS: {
        id: 4,
        name: 'Local Business',
        key: 'LBUSINESS',
        price: 500,
        pricingId: 'price_1I6te9JiTZl5BBha80Qx8AV0',
        period: 'Per Year',
        defaultRoleKey: 'inspire_corp',
    },
    CAMPUS: {
        id: 2,
        name: 'School',
        key: 'CAMPUS',
        price: 29,
        pricingId: 'price_1I1XsNJiTZl5BBha3OF3i368',
        period: 'Per Quarter',
        defaultRoleKey: 'inspire_campus',
    },
};

export const ROLE_CONTRIBUTOR = 1;
export const ROLE_PAID_CONTRIBUTOR = 2;
export const ROLE_PARTNER = 3;
export const ROLE_SUPER_ADMIN = 4;

export const ROLES = [
    ROLE_CONTRIBUTOR,
    ROLE_PAID_CONTRIBUTOR,
    ROLE_PARTNER,
    ROLE_SUPER_ADMIN,
];

/**
 * @description - Permission keys to determine access to certain parts of dashbaord
 */
export const DASHBOARD_VIEW = 'pp_dashboard_view';
export const RESEARCH_MANAGEMENT = 'research_management_view';
export const RESOURCES_VIEW = 'resources_view';
export const RESEARCH_VIEW = 'pp_research_management_view';
export const RESOURCES_FAQ_VIEW = 'resources_faq_view';
export const CHALLENGE_VIEW = 'pp_challenge_view';
export const CAMPAIGN_LIST_VIEW = 'pp_challenge_campaign_list';
export const CAMPAIGN_VIEW = 'pp_challenge_campaign_view';
export const CHALLENGE_DETAILS_VIEW = 'pp_challenge_details';
export const SEGMENTS_VIEW = 'pp_segments_view';
export const REPORT_VIEW = 'pp_report_download';
export const ADMIN_VIEW = 'pp_admin_view';
export const ANALYSIS_VIEW = 'pp_analysis_view';
export const TAXONOMY_BRAND_VIEW = 'pp_taxonomy_brand_view';
export const DASHBOARD_ADMIN_VIEW = 'dashboard_admin_view';
export const MULTILITTER_VIEW = 'multi_litter_list';

export const PARTNER_TOKEN_GENERATE = 'pp_partner_token_generate';
export const FB_SIGNIN_ERROR_MSG = 'User does not exist';

export const PERMISSIONS = [
    DASHBOARD_VIEW,
    CHALLENGE_VIEW,
    CHALLENGE_DETAILS_VIEW,
    SEGMENTS_VIEW,
    REPORT_VIEW,
    RESOURCES_VIEW,
    RESEARCH_VIEW,
    ADMIN_VIEW,
];

export const EMAIL_TO = ['newpayments@litterati.org'];

export function paymentEmailBody(
    username,
    email,
    activePackage,
    price,
    dateTime,
) {
    dateTime = dateTime ? dateTime : new Date().toGMTString();
    return `
<div style="text-align:center;">
    <h3 style="margin-bottom: 25px;">Welcome!</h3>
    <p style="margin-bottom: 25px;">Looks like we've got a new Partner on-board!</p>
    <table style="width:100%; color:#027aff; text-align:center; border:solid 1px black;">
        <tr>
            <th style="border-bottom:solid 1px black; border-right:solid 1px black; padding: 4px 0px;">Username</th>
            <th style="border-bottom:solid 1px black; border-right:solid 1px black; padding: 4px 0px;">Email</th>
            <th style="border-bottom:solid 1px black; border-right:solid 1px black; padding: 4px 0px;">Package Name</th>
            <th style="border-bottom:solid 1px black; border-right:solid 1px black; padding: 4px 0px;">Amount</th>
            <th style="border-right:none; border-bottom:solid 1px black; padding: 4px 0px;">Payment Date</th>
        </tr>
        <tr>
            <td style="border-right:solid 1px black; padding: 4px 0px;" >${username}</td>
            <td style="border-right:solid 1px black; padding: 4px 0px;" >${email}</td>
            <td style="border-right:solid 1px black; padding: 4px 0px;" >${activePackage}</td>
            <td style="font-weight:bold; border-right:solid 1px black; padding: 4px 0px;">$${price}</td>
            <td style="border:none; padding: 4px 0px;">${dateTime}</td>
        </tr>
    </table>

     <p style="margin-top:25px; margin-bottom: 5px;">Sincerely,</p>
    <p style="margin-top: 0px;">The Litterati Team</p>
</div>
    `;
}
